import React from 'react';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';

export default function Forbidden(): JSX.Element {
  return (
    <WhitePad>
      <h1>No permissions</h1>
      <p>
        You don't seem to have permissions to access this page. If you believe there is an error please get in
        touch with your admin.
      </p>
    </WhitePad>
  );
}
